import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

export interface CardItem {
  icon?: string;
  text: string;
  description: string;
  route: string;
  className?: string;
  show?: boolean;
}

@Component({
  selector: 'app-card-grid',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './card-grid.component.html',
  styleUrl: './card-grid.component.scss'
})
export class CardGridComponent {
  @Input() items: CardItem[] = [];
  @Input() containerWidth = '1200px';
}
